<template>
  <v-main>
    <v-container fluid>
      <v-row>
        <v-col md="12">
          <v-card elevation="6" rounded="xxl">
            <v-card-title>
              <h3
                class="font-weight-bold"
                v-text="
                  isDeletePage() != true ? 'Franchises' : 'Deleted Franchises'
                "
              ></h3>
              <section v-if="isDeletePage() != true">
                <v-btn v-can:add="['franchisees', 'franchise_details']"
                  class="mx-2 mb-2"
                  fab
                  x-small
                  color="primary"
                  to="/franchisees/create"
                >
                  <v-icon dark> mdi-plus </v-icon>
                </v-btn>
              </section>
            </v-card-title>
            <v-card-text>
              <v-row>
                <v-col md="6">
                  <v-text-field
                    solo
                    rounded
                    hide-details="auto"
                    v-model="filter.search_keyword"
                    label="Search ... "
                    prepend-inner-icon="mdi-magnify"
                    clearable
                    @click:clear="
                      (filter.search_keyword = null), (page = 1), getData()
                    "
                    @keydown.enter="(page = 1), getData()"
                  ></v-text-field>
                </v-col>
                <v-col sm="3">
                  <v-autocomplete
                    ref="status"
                    solo
                    hide-details="auto"
                    rounded
                    v-model="filter.is_active"
                    :items="statuses"
                    label="Status"
                    @click:clear="(filter.is_active = null), (page = 1)"
                    @input="(page = 1), getData()"
                    placeholder="Filter by Active Status"
                    prepend-inner-icon="mdi-toggle-switch"
                    clearable
                  ></v-autocomplete>
                </v-col>
                <v-col sm="3">
                  <v-autocomplete
                    ref="status"
                    solo
                    hide-details="auto"
                    rounded
                    v-model="filter.status"
                    :items="approvalStatus"
                    label="Approval Status"
                    @click:clear="(filter.status = null), (page = 1)"
                    @input="(page = 1), getData()"
                    prepend-inner-icon="mdi-toggle-switch"
                    clearable
                  ></v-autocomplete>
                </v-col>
                <v-col sm="3">
                  <v-autocomplete
                    ref="status"
                    solo
                    hide-details="auto"
                    rounded
                    v-model="filter.is_kyc_valid"
                    @click:clear="(filter.is_kyc_valid = null), (page = 1)"
                    :items="kycTypeItems"
                    label="KYC Status"
                    @input="(page = 1), getData()"
                    prepend-inner-icon="mdi-checkbox-marked-circle"
                    clearable
                  ></v-autocomplete>
                </v-col>
                <v-col sm="3" v-if="positionName !== 'MASTER FRANCHISEE'">
                  <v-autocomplete
                    ref="zone"
                    solo
                    hide-details="auto"
                    rounded
                    @click:clear="(filter.zone_id = null), (page = 1)"
                    v-model="filter.zone_id"
                    :items="zoneItems"
                    label="Zone"
                    @input="(page = 1), getData()"
                    placeholder="Filter by Zone"
                    prepend-inner-icon="mdi-map-marker"
                    clearable
                  ></v-autocomplete>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <v-row>
        <v-col md="12">
          <v-card elevation="6" rounded="xxl">
            <v-card-text>
              <section v-if="isLoading" style="height: 575px">
                <v-progress-linear
                  indeterminate
                  color="primary"
                ></v-progress-linear>
              </section>
              <v-simple-table
                v-else
                fixed-header
                height="575"
                class="striped-table"
              >
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th class="text-left">Sr No</th>
                      <th class="text-left">Status</th>
                      <th class="text-left">Approval Status</th>
                      <th class="text-left">KYC Status</th>
                      <th class="text-left">Name</th>
                      <th class="text-left">Address</th>
                      <th class="text-left">Description</th>
                      <th class="text-left">Email</th>
                      <th class="text-left">Phone</th>
                      <th class="text-left">Latitude</th>
                      <th class="text-left">Longitude</th>
                      <th class="text-left">Zone</th>
                      <th class="text-left">Rejection Reason</th>
                      <th class="text-left" style="min-width: 160px">
                        Created At
                      </th>
                      <th class="text-right action_th">Action</th>
                    </tr>
                  </thead>
                  <tbody v-if="franchisees.length != 0">
                    <tr
                      v-for="(franchisee, i) in franchisees"
                      :key="`franchisee${i}`"
                    >
                      <td style="min-width: 85px">
                        {{ i + 1 }}
                      </td>
                      <td>
                        <v-tooltip bottom v-if="franchisee.is_active == 1">
                          <template v-slot:activator="{ on, attrs }">
                            <v-chip
                              v-bind="attrs"
                              v-on="on"
                              small
                              color="teal"
                              text-color="white"
                            >
                              <v-avatar left>
                                <v-icon size="15"
                                  >mdi-checkbox-marked-circle</v-icon
                                >
                              </v-avatar>
                              Active
                            </v-chip>
                          </template>
                          <span>Franchisee is Active</span>
                        </v-tooltip>
                        <v-tooltip bottom v-if="franchisee.is_active == 0">
                          <template v-slot:activator="{ on, attrs }">
                            <v-chip
                              v-bind="attrs"
                              v-on="on"
                              small
                              color="red"
                              text-color="white"
                            >
                              <v-avatar left>
                                <v-icon size="15">mdi-close-circle</v-icon>
                              </v-avatar>
                              Inactive
                            </v-chip>
                          </template>
                          <span>Franchisee is InActive</span>
                        </v-tooltip>
                      </td>
                      <td>
                        <v-tooltip bottom v-if="franchisee.status == 1">
                          <template v-slot:activator="{ on, attrs }">
                            <v-chip
                              v-bind="attrs"
                              v-on="on"
                              small
                              color="teal"
                              text-color="white"
                            >
                              <v-avatar left>
                                <v-icon size="15"
                                  >mdi-checkbox-marked-circle</v-icon
                                >
                              </v-avatar>
                              Approved
                            </v-chip>
                          </template>
                          <span>Franchisee is Approved</span>
                        </v-tooltip>
                        <v-tooltip bottom v-if="franchisee.status == 0">
                          <template v-slot:activator="{ on, attrs }">
                            <v-chip
                              v-bind="attrs"
                              v-on="on"
                              small
                              color="yellow"
                              text-color="black"
                            >
                              <v-avatar left>
                                <v-icon size="15">mdi-close-circle</v-icon>
                              </v-avatar>
                              Pending
                            </v-chip>
                          </template>
                          <span>Waiting for Approval</span>
                        </v-tooltip>
                        <v-tooltip bottom v-if="franchisee.status == 2">
                          <template v-slot:activator="{ on, attrs }">
                            <v-chip
                              v-bind="attrs"
                              v-on="on"
                              small
                              color="red"
                              text-color="white"
                            >
                              <v-avatar left>
                                <v-icon size="15">mdi-close-circle</v-icon>
                              </v-avatar>
                              Rejected
                            </v-chip>
                          </template>
                          <span>Franchisee is Rejected</span>
                        </v-tooltip>
                      </td>
                      <td>
                        <v-tooltip bottom v-if="franchisee.is_kyc_valid == 1">
                          <template v-slot:activator="{ on, attrs }">
                            <v-chip
                              v-bind="attrs"
                              v-on="on"
                              small
                              color="teal"
                              text-color="white"
                            >
                              <v-avatar left>
                                <v-icon size="15"
                                  >mdi-checkbox-marked-circle</v-icon
                                >
                              </v-avatar>
                              Verified
                            </v-chip>
                          </template>
                          <span>Franchisee has completed the KYC</span>
                        </v-tooltip>
                        <v-tooltip bottom v-if="franchisee.is_kyc_valid == 0">
                          <template v-slot:activator="{ on, attrs }">
                            <v-chip
                              v-bind="attrs"
                              v-on="on"
                              small
                              color="red"
                              text-color="white"
                            >
                              <v-avatar left>
                                <v-icon size="15">mdi-close-circle</v-icon>
                              </v-avatar>
                              Pending
                            </v-chip>
                          </template>
                          <span>KYC pending</span>
                        </v-tooltip>
                      </td>
                      <td>{{ franchisee.name || "" }}</td>
                      <td style="min-width: 250px">
                        {{ franchisee.address || "" }}
                      </td>
                      <td style="min-width: 250px">
                        {{ franchisee.description || "" }}
                      </td>
                      <td>{{ franchisee.email || "" }}</td>
                      <td>{{ franchisee.phone || "" }}</td>
                      <td>{{ franchisee.latitude || "" }}</td>
                      <td>{{ franchisee.longitude || "" }}</td>
                      <td style="min-width: 155px">
                        <v-select
                          v-if="positionName !== 'MASTER FRANCHISEE'"
                          :items="zoneItems"
                          item-text="text"
                          item-value="value"
                          v-model="franchisee.zone_id"
                          @change="updateZone(franchisee)"
                          dense
                          outlined
                          hide-details
                        ></v-select>
                        <span v-else>
                          {{ getZoneName(franchisee.zone_id) }}
                        </span>
                      </td>
                      <td>{{ franchisee.rejection_reason || "" }}</td>

                      <td style="min-width: 160px">
                        {{ formatDate(franchisee.created_at) }}
                      </td>
                      <td
                        class="text-right"
                        style="min-width: 260px; white-space: nowrap"
                      >
                        <template v-if="isDeletePage() != true">
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn v-can:delete="['franchisees', 'franchise_details']"
                                v-bind="attrs"
                                v-on="on"
                                fab
                                x-small
                                class="my-auto"
                                color="error"
                                @click="OpenWarning(franchisee.id)"
                              >
                                <v-icon dark> mdi-delete </v-icon>
                              </v-btn>
                            </template>
                            <span>Delete this franchisee</span>
                          </v-tooltip>
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                v-bind="attrs"
                                v-on="on"
                                class="ml-2"
                                fab
                                x-small
                                color="primary"
                                :to="`/franchisees/${encryptIt(franchisee.id)}`"
                              >
                                <v-icon dark> mdi-pencil </v-icon>
                              </v-btn>
                            </template>
                            <span>Edit this franchisee</span>
                          </v-tooltip>
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                v-bind="attrs"
                                v-on="on"
                                class="ml-2"
                                fab
                                x-small
                                color="primary"
                                :to="`/franchisee-staffs?franchisee_id=${encryptIt(
                                  franchisee.id
                                )}`"
                              >
                                <v-icon dark> mdi-eye </v-icon>
                              </v-btn>
                            </template>
                            <span>View Staff</span>
                          </v-tooltip>
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                v-bind="attrs"
                                v-on="on"
                                class="ml-2"
                                fab
                                x-small
                                color="primary"
                                :to="`/franchisee-kyc-documents?franchisee_id=${encryptIt(
                                  franchisee.id
                                )}`"
                              >
                                <v-icon dark>
                                  mdi-card-account-details-star
                                </v-icon>
                              </v-btn>
                            </template>
                            <span>View KYC Document</span>
                          </v-tooltip>
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                v-bind="attrs"
                                v-on="on"
                                class="ml-2"
                                fab
                                x-small
                                color="primary"
                                :to="`/franchisee-time-slots?franchisee_id=${encryptIt(
                                  franchisee.id
                                )}`"
                              >
                                <v-icon dark> mdi-clock-outline </v-icon>
                              </v-btn>
                            </template>
                            <span>View Time Slots</span>
                          </v-tooltip>
                        </template>
                        <template v-else>
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn v-can:delete="['franchisees', 'franchise_details']"
                                v-bind="attrs"
                                v-on="on"
                                fab
                                x-small
                                class="my-auto"
                                color="error"
                                @click="Restore_this(franchisee.id)"
                              >
                                <v-icon dark> mdi-delete-restore </v-icon>
                              </v-btn>
                            </template>
                            <span>Restore this franchisee</span>
                          </v-tooltip>
                        </template>
                      </td>
                    </tr>
                  </tbody>
                  <tbody v-else>
                    <tr>
                      <td colspan="12" class="text-center">No data found</td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
              <v-pagination v-model="page" :length="paginationLength">
              </v-pagination>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <v-dialog v-model="deleteDialog" width="550px">
        <v-card rounded="xxl">
          <v-container>
            <v-row align="center">
              <v-col sm="3">
                <v-icon
                  large
                  style="color: green; font-size: 90px; width: 150px"
                >
                  mdi-delete-alert
                </v-icon>
              </v-col>
              <v-col sm="9" align="center">
                <v-card-text>
                  <v-row>
                    <v-col>
                      <h1 style="color: green">Warning!</h1>
                      <br />
                      <h3>Are you sure you want to delete this?</h3>
                      <br />
                      <v-btn color="grey" dark @click="deleteDialog = false"
                        >Cancel</v-btn
                      >
                      <v-btn
                        color="red"
                        dark
                        class="ml-5"
                        @click="Delete_this(to_be_deleted_id)"
                        >Delete</v-btn
                      >
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-dialog>
      <!-- Clear Success Dialog Box -->
      <v-dialog v-model="is_deleted_franchisee" width="600">
        <v-card rounded="xxl">
          <v-container>
            <v-row align="center">
              <v-col sm="3" align="center">
                <v-icon
                  large
                  style="color: green; font-size: 90px; width: 200px !important"
                >
                  mdi-delete-empty
                </v-icon>
              </v-col>
              <v-col sm="9" align="center">
                <v-card-text>
                  <v-row>
                    <v-col>
                      <h1 style="color: green">Hurray!</h1>
                      <br />
                      <h3>Franchisee deleted successfully.</h3>
                      <br />
                      <v-btn
                        color="success"
                        @click="is_deleted_franchisee = false"
                      >
                        OK
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-dialog>
      <!-- Restore Success Dialog Box -->
      <v-dialog v-model="is_restored_franchisee" width="600">
        <v-card rounded="xxl">
          <v-container>
            <v-row align="center">
              <v-col sm="3" align="center">
                <v-icon
                  large
                  style="color: green; font-size: 90px; width: 200px !important"
                >
                  mdi-delete-restore
                </v-icon>
              </v-col>
              <v-col sm="9" align="center">
                <v-card-text>
                  <v-row>
                    <v-col>
                      <h1 style="color: green">Hurray!</h1>
                      <br />
                      <h3>Franchisee restored successfully.</h3>
                      <br />
                      <v-btn
                        color="success"
                        @click="is_restored_franchisee = false"
                      >
                        OK
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-dialog>
    </v-container>
  </v-main>
</template>

<script>
import axios from "axios";
export default {
  name: "franchiseesPage",
  data() {
    return {
      filter: {
        active: "",
      },
      page: 1,
      serialNoStarting: 1,
      paginationLength: 0,
      count: 0,
      is_deleted_franchisee: false,
      restore_franchisee: false,
      is_restored_franchisee: false,
      franchisees: [],
      to_be_deleted_id: "",
      deleteDialog: false,
      statuses: [
        { id: "ACTIVE", text: "ACTIVE", value: "1" },
        { id: "INACTIVE", text: "INACTIVE", value: "0" },
      ],
      approvalStatus: [
        {
          id: 0,
          text: "PENDING",
          value: "0",
        },
        { id: "APPROVED", text: "APPROVED", value: "1" },
        { id: "REJECTED", text: "REJECTED", value: "2" },
      ],
      kycTypeItems: [
        { id: "COMPLETED", text: "COMPLETED", value: "1" },
        { id: "PENDING", text: "PENDING", value: "0" },
      ],
      positions: [
        {
          id: 0,
          text: "Select Position",
          value: "",
        },
      ],
      zoneItems: [],
      isLoading: false,
      isMasterLoading: false,
      isExcelloading: false,
      ExportFranchisees: [],
      Export_franchisees: [],
      excel_fields: {},
    };
  },
  watch: {
    page: "getData",
    $route() {
      this.getData();
    },
  },
  mounted() {
    this.getData();
    this.getMasters();
  },
  methods: {
    formatDate(value) {
      if (!value) return "";
      try {
        const d = new Date(value);
        const pad = (n) => String(n).padStart(2, "0");
        const day = pad(d.getDate());
        const month = pad(d.getMonth() + 1);
        const year = d.getFullYear();
        const hours = pad(d.getHours());
        const minutes = pad(d.getMinutes());
        const seconds = pad(d.getSeconds());
        return `${day}-${month}-${year} ${hours}:${minutes}:${seconds}`;
      } catch (e) {
        return value;
      }
    },
    async getMasters() {
      this.isMasterLoading = true;
      await axios
        .get(`masters?context=franchisees`)
        .then((masters) => {
          masters = masters.data;
          //Position
          masters.zones.forEach((zone) => {
            this.zoneItems.push({
              id: zone.id,
              text: zone.description,
              value: zone.id,
            });
          });
        })
        .catch((error) => {
          console.error(error);
          this.isUnAuthorised();
        });
      this.isMasterLoading = false;
    },
    async getData() {
      console.log("Get Data");
      this.filter.show_deleted = this.$route.query.open_trash ? 1 : 0;
      this.isLoading = true;
      this.filter.search_keyword = this.filter.search_keyword
        ? this.filter.search_keyword
        : "";
      this.filter.is_active = this.filter.is_active
        ? this.filter.is_active
        : "";
      this.filter.status = this.filter.status ? this.filter.status : "";
      this.filter.is_kyc_valid = this.filter.is_kyc_valid
        ? this.filter.is_kyc_valid
        : "";
      this.filter.position_id = this.filter.position_id
        ? this.filter.position_id
        : "";
      this.filter.zone_id = this.filter.zone_id ? this.filter.zone_id : "";
      let query =
        "page=" +
        this.page +
        "&rowsPerPage=" +
        this.rowsPerPage +
        "&role_id=4" +
        "&show_deleted=" +
        this.filter.show_deleted +
        "&is_active=" +
        this.filter.is_active +
        "&status=" +
        this.filter.status +
        "&is_kyc_valid=" +
        this.filter.is_kyc_valid +
        "&position_id=" +
        this.filter.position_id +
        (this.filter.zone_id ? "&zone_id=" + this.filter.zone_id : "") +
        "&search_keyword=" +
        this.filter.search_keyword;
      await axios
        .get(`franchisees?${query}`)
        .then((response) => {
          this.franchisees = response.data.data;
          this.count = response.data.count;
          this.serialNoStarting = (this.page - 1) * this.rowsPerPage;
          this.paginationLength = Math.ceil(this.count / this.rowsPerPage);
        })
        .catch((error) => {
          console.error(error);
          this.isUnAuthorised();
          // window.location.href = "/auth/login";
        });
      this.isLoading = false;
    },
    getZoneName(zoneId) {
      if (!zoneId) return "";
      const zone = this.zoneItems.find(item => item.value == zoneId);
      return zone ? zone.text : "";
    },
    async updateZone(franchisee) {
      try {
        const reqID = this.encryptIt(franchisee.id);
        const payload = {
          zone_id: franchisee.zone_id
        };
        
        await axios.patch(`/franchisees/${reqID}`, payload);
        this.isShowPopUP("Success", "Zone updated successfully", "success");
      } catch (error) {
        console.error(error);
        this.isUnAuthorised();
      }
    },
    OpenWarning(Franchisee_id) {
      console.log("Show Warning");
      this.is_confirmed_delete = false;
      this.to_be_deleted_id = Franchisee_id;
      this.deleteDialog = true;
    },
    async Delete_this(id) {
      this.deleteDialog = false;
      this.delete_franchisee = true;
      await axios
        .post(`/franchisees/delete/${this.encryptIt(id)}`)
        .then(() => {
          this.delete_franchisee = false;
          this.is_deleted_franchisee = true;
          this.getData();
        })
        .catch((error) => {
          console.error(error);
          this.isUnAuthorised();
        });
    },
    async addToExcelData() {
      this.isExcelLoading = true;
      this.title = "Company Lists";
      let Export_franchisees = [];
      this.search_keyword = this.search_keyword ? this.search_keyword : "";
      let query =
        "search_keyword=" +
        this.search_keyword +
        "&is_active=" +
        this.filter.active +
        "&roleId=" +
        this.filter.role_id;
      Export_franchisees = await axios.get(`franchisees?${query}`);
      this.Export_franchisees = Export_franchisees.data.data;

      this.Export_franchisees.forEach((franchisee) => {
        this.ExportFranchisees.push({
          sr_no: franchisee.sr_no,
          name: franchisee.name ? franchisee.name.toUpperCase() : "",
          email: franchisee.email ? franchisee.email.toUpperCase() : "",
          phone: franchisee.phone ? franchisee.phone : "",

          supervisor: franchisee.supervisor_id
            ? franchisee.supervisor.name.toUpperCase()
            : "",
          status: franchisee.active == 1 ? "YES" : "NO",
        });
      });
      this.isExcelLoading = false;
    },
    async generateExcel() {
      this.isExcelLoading = true;
      this.filter.search_keyword = this.filter.search_keyword
        ? this.filter.search_keyword
        : "";
      this.filter.is_active = this.filter.is_active
        ? this.filter.is_active
        : "";
      this.filter.position_id = this.filter.position_id
        ? this.filter.position_id
        : "";
      let response = [];
      let query =
        "role_id=4" +
        "&companyId=" +
        this.company.id +
        "&is_active=" +
        this.filter.is_active +
        "&position_id=" +
        this.filter.position_id +
        "&search_keyword=" +
        this.filter.search_keyword;
      response = await axios
        .get(`/franchisees/excel_export?${query}`)
        .then((response) => window.open(`${response.data.data}`, "_blank"));
      if (response) {
        console.log(response);
      }
      this.isExcelloading = false;
    },
    isDeletePage() {
      let response = false;
      if (this.$route.query.open_trash) {
        response = true;
      }
      return response;
    },
    async Restore_this(id) {
      this.restore_franchisee = true;
      await axios
        .post(`/franchisees/restore/${this.encryptIt(id)}`)
        .then(() => {
          this.restore_franchisee = false;
          this.is_restored_franchisee = true;
          this.getData();
        })
        .catch((error) => {
          console.error(error);
          this.isUnAuthorised();
          // window.location.href = "/auth/login";
        });
    },
  },
};
</script>
